import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SessionStep } from '@core/models/session.model';
import { TranslocoService } from '@ngneat/transloco';
import { AlertSmsJson } from '@procedure-steps/alert-sms/alert-sms-json.model';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

import it from './i18n/alert-sms-report.it.json';

@Component({
  templateUrl: './alert-sms-report.component.html',
  styles: [`
    ul {
      list-style: none;
      padding: 0;
      margin: 0;
    }
  `]
})
export class AlertSmsReportComponent implements OnChanges {

  @Input() step!: SessionStep;

  private step$$ = new BehaviorSubject<SessionStep>(this.step);
  step$ = this.step$$.asObservable();

  values$ = this.step$.pipe(
    map(step => step.values || []),
    map(values => values.map(v => v.value as AlertSmsJson)),
  );

  constructor(
    private translocoSvc: TranslocoService
  ) {
    this.translocoSvc.setTranslation(it, 'it');
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.step) {
      this.step$$.next(changes.step.currentValue);
    }
  }

}
